import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the script step; each part uses its own slice of it */
import styles from './Script.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ShotThumbProps {
  /** The 1-based number of the shot in the script. */
  number: number;
  /** "Clip 3" or "Clip 3 · 5.0 s in"; none on the phone list. */
  clipLabel?: string;
  /** The camera of the shot; shown on the placeholder only. */
  camera?: string;
  /** A still of the made clip (`DirectedVideoClipEntry.stillUrl`), else null: the placeholder. */
  stillUrl: string | null;
  /** The small tile of the phone list. */
  compact?: boolean;
}

/**
 * The tile of one shot. Before the make there is no picture of the shot, so the tile is a neutral
 * placeholder with the shot number and the camera; after the make it shows a still of its clip.
 * It never shows the cover art of the song (owner rule 2026-10-18).
 */
const ShotThumbComponent: React.FC<ShotThumbProps> = ({ number, clipLabel, camera, stillUrl, compact = false }) => (
  <div className={clsx(styles.thumb, compact && styles.thumbCompact, stillUrl === null && styles.thumbPlaceholder)}>
    {stillUrl !== null ? (
      <img src={stillUrl} alt="" loading="lazy" />
    ) : (
      <>
        <span className={styles.thumbNumber} aria-hidden>
          {number}
        </span>
        {!compact && camera !== undefined && camera.trim() !== '' && (
          <span className={styles.thumbCamera} title={camera}>
            {camera}
          </span>
        )}
      </>
    )}
    {clipLabel !== undefined && <span className={styles.clipLabel}>{clipLabel}</span>}
  </div>
);

export const ShotThumb = TypedMemo(ShotThumbComponent);
